import { useQuery } from "@apollo/client";
import { productsByTenantGQL } from "../graphql";
import { getImages } from "../constants/services";

export interface TenantProduct {
  id: string;
  appUrl: string;
  productBranding?: {
    icon: string;
    title: string;
  };
}

// Shared tenant products data + icon resolution (category icon -> tenant product icon -> default image).
export function useProductByTenants() {
  const { data } = useQuery<{
    productsByTenant: { items: TenantProduct[] };
  }>(productsByTenantGQL, {
    variables: { input: {} },
  });

  const products = data?.productsByTenant.items ?? [];

  const getProductIcon = (id: string) =>
    products.find((product) => product.id === id)?.productBranding?.icon ||
    getImages(id);

  return { products, getProductIcon };
}
